// Every change to a list goes through here: the API call, the list's queries refreshed (and the
// groups' network summaries, which name it), a toast, or the API's reason as a warning.
import { useQueryClient } from "@tanstack/react-query";

import { toast } from "../layout/toast";
import type { NetworkList } from "./api";

export function useListChange() {
  const queryClient = useQueryClient();
  return async function change<T>(call: () => Promise<T>, done: (result: T) => string): Promise<T | undefined> {
    try {
      const result = await call();
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["network-lists"] }),
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey[0] === "task-groups" && q.queryKey[2] === "network" }),
      ]);
      toast(done(result));
      return result;
    } catch (e) {
      toast(e instanceof Error ? e.message : String(e), "warn");
      return undefined;
    }
  };
}

export type ListChange = ReturnType<typeof useListChange>;
export type { NetworkList };
